module.exports = __webpack_public_path__ + "static/img/voice4_left.9c126aa7.png";